/*    
<summary>
   This component manages reservation settings & performs CRUD operations.
   CRUD (Create, Read, Update, Delete)
   Developer: Aashish Singh, Created Date: 25-Aug-2022, 
   Last Updated By: Mohammad Saquib Khan, Updated Date: 05-Dec-2022
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React from "react";
import { useStore } from "../../../contexts/store-provider";
import AddEditCustomerRegistration from "./components/add-edit-customer-registration";

const CustomerRegistration: React.FC = (props: any) => {
    const { preferencesStore, masterManagementStore } = useStore();

    return (
        <div className="bg-img1 background">
            <AddEditCustomerRegistration />
        </div>
    );
};

export default observer(CustomerRegistration);
